import { useMutation } from '@apollo/client';
import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ROUTES } from '../../../common/constants';
import GoBackButton from '../../../components/GoBackButton';
import Portal from '../../../components/Portal';
import ProductCategoryForm from '../components/ProductCategoryForm';
import { CREATE_PRODUCT_CATEGORY } from '../graphql/Mutations';

function ProductCategoryCreate(props) {
  const { history = null, location = null } = props;
  const [submitLoading, setSubmitLoading] = useState(false);

  const [createProductCategoryMutate] = useMutation(CREATE_PRODUCT_CATEGORY, {
    onError: () => {
      setSubmitLoading(false);
    }
  });

  useEffect(() => {
    return () => {
      if (history?.action === 'POP') {
        history?.push(history?.pathname, {
          ...location?.state
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleSubmit = async (formValues) => {
    setSubmitLoading(true);

    const newFormValues = {
      ...formValues
    };

    const variables = newFormValues;

    try {
      const response = await createProductCategoryMutate({
        variables: { data: { ...variables } }
      });
      if (response?.data?.createProductCategory) {
        history?.push(ROUTES?.PRODUCT_CATEGORIES, { ...location?.state });
      }
      setSubmitLoading(false);
    } catch (error) {
      setSubmitLoading(false);
      return error;
    }
  };

  const initialValues = {
    description: ''
  };

  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <div className="d-flex align-center">
          <GoBackButton customLink={ROUTES?.PRODUCT_CATEGORIES} />
          <span className="portal-header">Add Category</span>
        </div>
      </Portal>
      <ProductCategoryForm
        productCategoryData={initialValues}
        handleSubmit={handleSubmit}
        isSubmit={submitLoading}
      />
    </Card>
  );
}

export default withRouter(ProductCategoryCreate);
